<template>
  <div v-bind:class="cardClass"
    @mouseover="hovering=true" 
    @mouseleave="hovering=false">
    <div class='embed-responsive embed-responsive-16by9 img-container ' >
      <template v-if="videoAsset.mux_asset">
        <img
          v-show="!hovering"
          class='card-img-top embed-responsive-item'
          :src="getPoster"
          :alt="videoAsset.title"
        >
        </img>
        <img
          v-show="hovering"
          class='card-img-top embed-responsive-item'
          :src="getGif"
          :alt="videoAsset.title"
        >
        </img>
      </template>
      <template v-else>
        <div
          class="card-img-top embed-responsive-item missing-mux-asset d-flex align-items-center justify-content-center"
        >Video Unavailable</div>
      </template>
    </div>

    <div class="media-body d-flex flex-column justify-content-between pl-2 pr-2">
      <div class="d-flex justify-content-between w-100">
        <h5 class='card-title'>{{ videoAsset.title }}</h5>
        <i :class="viewedIconClass" v-if="videoAsset.track_completion"></i>
      </div>
      <video-asset-duration
          :video-asset="videoAsset"
      ></video-asset-duration>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    videoAssetVideoPlaylist: {
      type: Object,
      required: true,
    },
    videoAsset: {
      type: Object,
      required: true
    },
    poster: {
      type: String,
      required: false
    },
    gif: {
      type: String,
      required: false
    },
    selected: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      hovering: false
    }
  },

  computed: {

    videoAssetCompleted () {
      return this.videoAsset && this.videoAsset.video_asset_completions && this.videoAsset.video_asset_completions.length;
    },
    
    viewedIconClass () {
      return this.videoAssetCompleted 
        ? 'fas fa-check-circle viewed' 
        : 'far fa-circle not-viewed';
    },

    cardClass () {
      return `card video-item-sidebar ${this.selected ? 'active-video-card' : ''} sidebar-card-vavp-${this.videoAssetVideoPlaylist.id}`
    },
    
    getPoster() {
      if (this.poster) return this.poster;
      if (this.videoAsset.custom_poster_image_enabled && this.videoAsset.poster_image_url) {
        return this.videoAsset.poster_image_url
      }
      else if(this.videoAsset.mux_asset && this.videoAsset.mux_asset.poster) {
        return this.videoAsset.mux_asset.poster
      }
      else {
        return null;
      }
    },

    getGif() {
      return this.gif || this.videoAsset.gif || this.videoAsset.mux_asset && this.videoAsset.mux_asset.gif;
    },

    muxAsset () {
      return this.videoAsset && this.videoAsset.mux_asset;
    },

    durationReadable () {
      var duration = this.muxAsset && this.muxAsset.duration
      if (!duration) return false;
      var date = new Date(null);
      date.setSeconds(duration);
      return date.toISOString().substr(11, 8);
    }
  }
}

</script>

<style scoped>
  .img-container {
    width: 100px;
  }

  .card:hover {
    cursor: pointer;
  }

  .video-playlist-container .active-video-card {
    background-color: var(--theme-primary-color);    
  }

  .baseEvent .video-playlist-container .active-video-card {
    background: var(--theme-content-bg-text-color-faded,rgba(34, 34, 34, 10));
  }

  .baseEvent .video-playlist-container .media-body {
    padding-right: 0px !important;
  }

  .baseEvent img.card-img-top.embed-responsive-item {
    object-fit: cover;
  }

  .viewed-status i {
    margin-right: 8px;
    font-size: 1.2em;
  }

  .viewed {
    color: #28a745;
  }

  .not-viewed {
    color: #6c757d;
  }

</style>